import { BORDER_STYLE, MAIN_STYLE_GROUPS, PRESS_EVENTS, SWIPE_GESTURES } from '../shared.js'
export const page = {
    // A page is an LVGL screen. openHASP installs generic_event_handler on the
    // screen, and this LVGL version initialises screens with click = 1, so an
    // empty page area can publish the generic touch lifecycle on object id 0.
    // Pages still do not receive focus events.
    focusable: false,

    parts: {
        main: {
            label: 'Main',
            exportSuffix: '',
            order: 0,
            propertyGroups: [...MAIN_STYLE_GROUPS],
            properties: {
                bg_color:     { type: 'color', format: 'hex8' },
                bg_opa:       { type: 'int', min: 0, max: 255, internal: true },
                radius:       { type: 'int', min: 0, max: 999 },
                ...BORDER_STYLE,
            },
        },
    },

    properties: {
        x:     { type: 'int' },
        y:     { type: 'int' },
        // ATTR_SWIPE dispatches to attribute_common_tag (hasp_attribute.cpp:2759-2760), storing
        // an arbitrary string tag — Page::swap wires every screen through generic_event_handler
        // (hasp_page.cpp:56) identically to buttons/objects. Same bug as btn.js/obj.js.
        swipe: { type: 'string' },
        // specific_page_attribute (hasp_attribute.cpp:1313-1348) implements real, settable
        // ATTR_NEXT/ATTR_PREV/ATTR_BACK int attributes controlling the page-navigation graph
        // (haspPages.set_next/prev/back). The underlying storage is a 3x 4-bit bitfield
        // (hasp_page_meta_data_t, hasp_page.h:18-22), so valid page ids are hard-capped at 0-15
        // regardless of HASP_NUM_PAGES (typically 4-12) — values above that silently truncate.
        next: { type: 'int', min: 0, max: 15 },
        prev: { type: 'int', min: 0, max: 15 },
        back: { type: 'int', min: 0, max: 15 },
        transition: { type: 'enum', values: ['none', 'slide'] },
        transition_direction: { type: 'enum', values: ['auto', 'left', 'right', 'up', 'down'] },
        transition_duration: { type: 'int', min: 0, max: 60000 },
    },

    defaults: { properties: { x: 0, y: 0 } },

    editorCapabilities:  ['has_objectmenu'],
    runtimeCapabilities: [],

    events: PRESS_EVENTS,
    // Logic-editor gestures; exported as the page record's `swipe` map.
    gestures: SWIPE_GESTURES,
    bindings: { properties: {}, actions: { hass_services: [] }, events: {} },
}
